import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCancelRegularReportIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 3.2a13 13 0 0 1 12.7 14.2l-.8-.1h-1.6V16A10.4 10.4 0 0 0 9.6 7.9l10.1 10-.1 1v1.4h-1L7.8 9.5A10.4 10.4 0 0 0 15 26.4v.7q0 1 .5 1.7A12.8 12.8 0 0 1 16 3.2m2.9 19q1 .2 1.1 1.2V27q-.1 1-1.1 1.1H18q-1-.1-1.1-1v-3.8q.1-1 1.1-1.1zm4.5-4.4q1 .1 1.1 1v8.3q-.1 1-1.1 1.1h-.8q-.8 0-1-.7l-.1-.4V19q.1-1 1.1-1.1zm4.5 1.4h.1l.3.2q.6.2.7 1V27q-.1 1-1.1 1.1H27q-1-.1-1.1-1v-6.8q.1-1 1.1-1.1z" })
});
export default SvgCancelRegularReportIcon;
